import listSaga from './listSaga'
import editServiceSaga from './editServiceSaga'
import oneServiceSaga from './oneServiceSaga'
import deleteServiceSaga from './deleteServiceSaga'
import createServiceSaga from './createServiceSaga'

const servicesSagas = [listSaga(), oneServiceSaga(), editServiceSaga(), deleteServiceSaga(), createServiceSaga()]

export default servicesSagas
